var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "t-list t-list--sortable" },
        [
          !_vm.$isEmpty(_vm.recommendedVideos)
            ? _vm._l(_vm.recommendedVideos, function (v) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "t-sortable",
                        rawName: "v-t-sortable",
                        value: _vm.sortable && _vm.onUpdateVideo,
                        expression: "sortable && onUpdateVideo",
                      },
                    ],
                    key: v.id,
                    staticClass: "t-list-item",
                    attrs: { "sort-handle": "t-list-handle" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "t-list-wrap t-flex t-flex--aic" },
                      [
                        _c("div", { staticClass: "t-flex__grow" }, [
                          _c("div", { staticClass: "t-flex t-flex--aic" }, [
                            _vm.sortable
                              ? _c("i", {
                                  staticClass:
                                    "fas fa-grip-vertical t-mar--r-xs t-list-handle fs-fw t-tc--muted",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c("span", { staticClass: "t-tc--primary" }, [
                                _vm._v(_vm._s(v.title)),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "t-button",
                          {
                            staticClass: "t-mar--l-md",
                            attrs: { variant: "action" },
                            on: {
                              click: function ($event) {
                                return _vm.removeVideoElement(v)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-times t-fs--caption",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "t-button",
            {
              staticClass: "t-mar--t-mi",
              attrs: { fluid: "" },
              on: {
                click: function ($event) {
                  return _vm.showRecommendedVideosModal()
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-plus" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("hub.content.add_videos")))]),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("SelectVideosModal", {
        on: { selectedVideos: _vm.addToRecommendedVideos },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }